import { render } from "./genderSelector.vue?vue&type=template&id=0f56ab62&ts=true"
import script from "./genderSelector.vue?vue&type=script&lang=ts"
export * from "./genderSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__